import { isNullOrUndefined } from './type';

export const isString = (value: unknown): value is string => {
	return typeof value === 'string' && value.constructor === String;
};

export const isBadOrEmptyString = (value: unknown): value is null | undefined | '' => {
	if (isNullOrUndefined(value)) {
		return true;
	}

	return String(value).trim().length === 0;
};

export const isEmptyString = (value: unknown): value is '' => {
	if (!isString(value)) {
		return false;
	}

	return value.length === 0;
};

export const isWhitespaceOrEmptyString = (value: unknown): value is '' | ' ' => {
	if (!isString(value)) {
		return false;
	}

	return value.trim().length === 0;
};
